import * as React from "react";
import { forwardRef } from "react";
import { styled } from "@mui/material";
import {
  ClosedMultipleQuestionView,
  ClosedMultipleQuestionViewProps,
  RenderChildrenAt,
} from "../ClosedMultipleQuestionView";
import { QualifiedFeature } from "fe-common/graphql";
import { scrollableStyleByColor } from "fe-common/ui/commonStyles";
import { PatientColorMap } from "../../../layout/patientColorMap";

//region [[ Styles ]]

const MedicationFrequencySelectorView = styled(ClosedMultipleQuestionView)({
  "& .answers-container": {
    maxHeight: "35vh",
    ...scrollableStyleByColor(PatientColorMap.Background2),
  },
  "& .question-options-container": {
    background: "transparent",
    marginTop: 0,
    paddingTop: 0,
  },
  "& .answer-chip": {
    backgroundColor: PatientColorMap.PrimaryLight,
  },
});

// const FilterInput = styled(InputBase)({
//   borderRadius: "8px",
//   border: "none",
//   margin: "10px 0",
//   padding: "5px 15px",
//   background: "white",
//   ...commonBoxShadowStyle,
// });
//endregion [[ Styles ]]

//region [[ Props ]]

export interface MedicationFrequencySelectorProps
  extends Omit<ClosedMultipleQuestionViewProps, "onDone"> {
  onFrequencySelected: (qf: QualifiedFeature) => void;
  medicationName: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MedicationFrequencySelector = forwardRef<
  HTMLDivElement,
  MedicationFrequencySelectorProps
>(({ suggestions, ...props }, ref) => {
  // const { translate } = useTranslate();

  // const [searchFilter, setSearchFilter] = useState<string>(null);

  // const filteredSuggestions = React.useMemo(() => {
  //   const fuse = new Fuse(suggestions, {
  //     keys: ["qualifiers.value.shortname"],
  //   });
  //   return searchFilter
  //     ? fuse.search(searchFilter || "").map((fr) => fr.item)
  //     : suggestions;
  // }, [suggestions, searchFilter]);

  const handleDone = (selected: Map<string, [QualifiedFeature, boolean]>) => {
    props.onFrequencySelected(selected.values().next().value[0]);
  };

  const qualifierLabeler = (q: QualifiedFeature) =>
    q.qualifiers.flatMap((qf) => qf.value.shortname);

  return (
    <MedicationFrequencySelectorView
      ref={ref}
      suggestions={suggestions}
      labeler={qualifierLabeler}
      singleSelect
      onDone={handleDone}
      onSelected={props.onFrequencySelected}
      renderChildrenAt={RenderChildrenAt.Top}
      {...props}
    >
      {/*<FilterInput*/}
      {/*  value={searchFilter}*/}
      {/*  onChange={(e) => setSearchFilter(e.target.value)}*/}
      {/*  placeholder={translate("MEDICATION_FILTER")}*/}
      {/*/>*/}
    </MedicationFrequencySelectorView>
  );
});
